import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import { IMG_BASE_URL } from "src/config/constants";
import Confirm from "src/components/common/ConfirmDialog";
import CellImage from "src/components/common/CellImage";
import { asyncRequest } from "src/services/network";

const TABLE_HEAD = [{ id: "id", label: "ID", alignRight: false }, { id: "cover", label: "封面", alignRight: false }, { id: "name", label: "商品名称", alignRight: false }, { id: "price", label: "售价", alignRight: false }, { id: "buyCount", label: "销量", alignRight: false }, { id: "stock", label: "库存", alignRight: false }, { id: "isShow", label: "上/下架", alignRight: false }, { id: "order", label: "排序", alignRight: false }, { id: "createdAt", label: "创建时间", alignRight: false }, { id: "操作" }];

const moreMenus = [
  { title: "编辑", icon: iconEdit2 },
  { title: "删除", icon: iconEdit2 },
];

export default function MerchantProductList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/store/baodan/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/product/edit/${row.id}`, { state: row });
    } else if (type === "删除") {
      handleDel(row);
    }
  };

  function handleDel({ id }) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        const { data } = await asyncRequest({
          path: "/store/baodan/del",
          data: { id },
        });

        setItems(items.filter((b) => b.id !== id));
      },
    });
  }

  async function toggleEnabled({ id, status }) {
    const toStatus = status !== 1 ? 1 : 0;
    await asyncRequest({
      path: "/store/product/edit",
      data: { id, status: toStatus },
    });

    const item = items.find((it) => it.id === id);
    item.status = toStatus;
    setItems([...items]);
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="报单产品列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            报单产品列表
          </Typography>

          <Button variant="contained" component={RouterLink} to="/product/add" startIcon={<Icon icon={plusFill} />}>
            添加产品
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, name, cover, isShow, createdAt, price, buyCount, stock, order, status } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, id)}
                            />
                          </TableCell> */}
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">
                          <CellImage src={cover} />
                        </TableCell>
                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{price}</TableCell>
                        <TableCell align="left">{buyCount}</TableCell>
                        <TableCell align="left">{stock}</TableCell>
                        <TableCell>
                          <Switch checked={status == 1} onChange={() => toggleEnabled(row)} />
                        </TableCell>
                        <TableCell align="left">{order}</TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
